import type { ButtonConfig } from '../../declare'
import { useMemo, useContext } from 'react'
import { ListPage, TreeContext } from 'src/components'
import { getDefaultValueFrom_DEFAULT_VALUE } from 'src/components/root/helper'
import { getSingleRule } from 'src/utils/common'

type Props = {
  config: ButtonConfig
}

const ListPageBtn = (props: Props) => {
  const tree = useContext(TreeContext)

  const filterGroup = useMemo<any>(() => {
    const Rules = []

    // 配置的自定义参数
    const { CUSTOM_PARAMS } = props.config
    if (CUSTOM_PARAMS && tree.selectedNodes.length) {
      const arrs = CUSTOM_PARAMS.split('=')
      if (arrs.length === 1) {
        Rules.push(getSingleRule(CUSTOM_PARAMS, 1, tree.selectedKeys.join(',')))
      } else {
        tree.selectedNodes.forEach((tree: any) => {
          const value = getDefaultValueFrom_DEFAULT_VALUE(arrs[1], { node: tree.Node })
          Rules.push(getSingleRule(arrs[0], 1, value))
        })
      }
    }

    return { Rules }
  }, [tree.selectedKeys, props.config.CUSTOM_PARAMS])

  const formData = useMemo(() => {
    return {
      filterGroup
    }
  }, [filterGroup])

  return (
    <ListPage
      formCode={props.config.FORM_CODE || tree.treeConfig.Nav_Form?.CODE}
      formData={formData}
    />
  )
}

export default ListPageBtn